import React from 'react';

import {
  WizardScreen,
  FooterMode
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';
import { WizardFormValidationErrorSummary } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-validation-error-summary/wizard-form-validation-error-summary';

import { CreateNewForecastForm } from '../../../components/forecast/create-new-forecast-form';
import { ForecastFormHelpText } from '../../../components/form-elements/forecast-form-help-text/forecast-form-help-text';
import { NewForecastDataSource } from '../../../../dashboard/types';
import { useCreateForecastWizardContext } from '../../../contexts/create-forecast-wizard-context';

export interface ThreeWayForecastFormWizardScreenProps {
  error?: string | boolean;
  onClose: () => void;
  onCreate: () => void;
}

export const ThreeWayForecastFormWizardScreen = ({
  error,
  onClose,
  onCreate
}: ThreeWayForecastFormWizardScreenProps) => {
  const { form, excelField, excelTemplate, kind, view } = useCreateForecastWizardContext();
  const { forecasts } = view.state;

  const { ...formState } = form;
  const { onChange: onChangeExcelFile, uploadStatus, error: excelFileError, file: excelFile } = excelField;
  const { data: excelTemplateData, isLoading: isLoadingExcelTemplate } = excelTemplate;

  return (
    <WizardScreen
      createDisabled={formState.datasource === NewForecastDataSource.FromExcelUpload && !excelFile}
      onCancel={onClose}
      onCreate={onCreate}
      footerMode={FooterMode.CREATE}
    >
      <>
        {error && <WizardFormError mb={3} message={typeof error === 'string' ? error : undefined} />}
        <WizardFormValidationErrorSummary errors={formState.errors} mb={3} />

        <CreateNewForecastForm
          {...formState}
          excelFileError={excelFileError}
          excelTemplateLink={excelTemplateData?.template_url}
          forecasts={forecasts}
          fileUploadStatus={uploadStatus}
          isLoadingExcelTemplate={isLoadingExcelTemplate}
          onChangeFile={onChangeExcelFile}
          type={formState.type}
        />
        <ForecastFormHelpText kind={kind} />
      </>
    </WizardScreen>
  );
};
